module.exports = __webpack_public_path__ + "img/login_bg.d6756cc9.png";